/**
 * 特集商品付替画面の付替対象商品一覧取得クラス
 *
 * @export FeatureGoods
 * @class FeatureGoods
 */
export class FeatureGoods {
	constructor(
		public OrderCode: string,
		public MediumType: string,
		public FeatureCode: string,
		public FeatureName: string,
		public BuyerNotice: string,
		public SupplierCode: string,
		public SupplierName: string,
		public PCode: string,
		public GuideGoodsName: string,
		public JanCode: string,
		public ItemCode: string,
		public GuideStandardName: string,
		public MakerName: string,
		public SupplyPriceStandard: string | number,
		public SupplyPrice: string | number,
		public CostPriceStandard: string | number,
		public CostPrice: string | number,
		public StockNum: string | number,
		public OrderUnitType: string,
		public NewUnitType: string,
		public PricePattern: string,
		public Remarks: string,
		public ReplacementStatus: string,
		public SelectorType: number,
	) {}
}
